import * as yup from 'yup';
import { MSJ_YUP, VALIDAR } from './mensajesGenericos';

const soloTrabajador = {
  is: "trabajador",
  then: (schema) => schema.required("Campo obligatorio"),
  otherwise: (schema) => schema.notRequired()
};

const esCrearUsuario = {
  is: true,
  then: (schema) => schema.required("Campo obligatorio"),
  otherwise: (schema) => schema.notRequired()
}

export const crearPersonaSchema = yup.object({
  rut:              VALIDAR.RUT,
  nombre:           VALIDAR.NOMBRE,
  apellido_paterno: VALIDAR.NOMBRE,
  apellido_materno: VALIDAR.NOMBRE,
  celular:          VALIDAR.CELULAR,
  correo:           VALIDAR.CORREO,
  region:           VALIDAR.SELECT,
  comuna:           VALIDAR.SELECT,
  perfil:           VALIDAR.SELECT,

  empresa:          VALIDAR.SELECT,
  centro_costo:     VALIDAR.SELECT,

  estado_civil:     VALIDAR.SELECT.when("perfil", soloTrabajador),
  direccion:        VALIDAR.TEXTO.when("perfil", soloTrabajador),
  direccion_numero: VALIDAR.TEXTO.when("perfil", soloTrabajador),
  sexo:             VALIDAR.SELECT.when("perfil", soloTrabajador),
  cargo:            VALIDAR.SELECT.when("perfil", soloTrabajador),

  fecha_ingreso: yup
    .date()
    .typeError(MSJ_YUP.FECHA)
    .min(new Date("2014-01-01"), "Fecha demasiado antigua")
    .when("perfil", soloTrabajador),
  
  fecha_nacimiento: yup
    .date()
    .typeError(MSJ_YUP.FECHA)
    .max(new Date(), "La fecha no puede ser futura")
    .when("perfil", soloTrabajador),

  contacto_nombre:     VALIDAR.NOMBRE_COMPLETO.when("perfil", soloTrabajador),
  contacto_parentesco: VALIDAR.SELECT.when("perfil", soloTrabajador),
  contacto_correo:     VALIDAR.CORREO.when("perfil", soloTrabajador),
  contacto_celular:    VALIDAR.CELULAR.when("perfil", soloTrabajador),

  crear_usuario:       yup.boolean(),
  usr_rol:             VALIDAR.SELECT.when("crear_usuario", esCrearUsuario),
})